import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  private activeDropdown = new BehaviorSubject<number | null>(null);
  activeDropdown$ = this.activeDropdown.asObservable();

  setActiveDropdown(id: number | null) {
    this.activeDropdown.next(id);
  }
}
